import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LogAnalytics.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/OpenTraining/OpenTrainingCard.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/NewsletterForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/PreRegisterOpenTrainingButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/ShareAction.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/TrustSponsor.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
